var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 8.00017V13.0002M12.75 16.0002V16.0102M5.08984 6.42282L11.7501 2.57752C12.3689 2.22025 13.1313 2.22025 13.7501 2.57752L20.4104 6.42282C21.0292 6.78008 21.4104 7.44034 21.4104 8.15487V15.8455C21.4104 16.56 21.0292 17.2203 20.4104 17.5775L13.7501 21.4228C13.1313 21.7801 12.3689 21.7801 11.7501 21.4228L5.08984 17.5775C4.47104 17.2203 4.08984 16.56 4.08984 15.8455V8.15487C4.08984 7.44034 4.47104 6.78008 5.08984 6.42282Z",
    stroke: "#FA8B16",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.9525b288e154cbd7ea57cde5dca7fd84.svg";
export { ForwardRef as ReactComponent };